module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAABC0lEQVRYhe2W0Q2CMBRFb42D6AYM0MS4gWwgCzAMC8AGzmDCAG6gI7hBzUsgqaWF8vqqP9wfoDQ5p4W2D1v+HZWLb2p9AHC1mjrV9C+3XxYBU2sCt55XlWr6LqvADHzM0Z6J3Y/hcD6LnEAkfBIRAS6ckizAgH/9hEkCDHjlLkX2KmDCO7eRJSAFZwlIwlcLSMNXCeSARwvkgkcJ5IQvCphaXwDccsEpSxsRbRrvXPCgABUTptatavoHgHOEBAseFABQ0LEZKcGGLwkgQiIJPidwsu5DEsnwOYHCeXYlSgk4ZbIMh2r2GehPlW0lAR6z97TZo6fpplHfh+tDEk7xCRC0JJivjt+yRTQAPmuGhLxhBIlmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/ic_btn_edit@2x.png
// module id = 723
// module chunks = 0